module.exports = __webpack_public_path__ + "media/images/front/about/aboutdba_point03-4-64fdbd7675142912949132ec5c5161cd.jpg";